import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineBedQueenIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20.98 10.3999v-4.7c0-1.2-1-2.3-2.2-2.3H5.38c-1.2 0-2.2 1-2.2 2.3v4.7c-1.1.4-1.9 1.6-1.9 2.9v4.5c0 .5.4 1 .9 1h1v.9c0 .5.4 1 .9 1s.9-.4.9-1v-.9h14v.9c0 .5.4 1 .9 1s.9-.4.9-1v-.9h1c.5 0 .9-.4.9-1v-4.5c.2-1.4-.6-2.5-1.7-2.9Zm-8.1-1.2c0-.3.2-.5.4-.5h2.6c.2 0 .4.2.4.5v1h-3.4v-1Zm-5.1 0c0-.3.2-.5.4-.5h2.5c.2 0 .4.2.4.5v1h-3.3v-1Zm8.2-2.4h-2.5c-.5 0-1 .2-1.3.5-.4-.3-.8-.5-1.4-.5h-2.6c-1.3 0-2.3 1.1-2.3 2.4v1h-.8v-4.5c0-.2.2-.4.3-.4h13.4c.2 0 .3.1.3.4v4.5h-.9v-1c0-1.3-1-2.4-2.2-2.4Zm5.1 6.5v3.5h-18v-3.5c0-.7.5-1.2 1.1-1.2h15.7c.6 0 1.2.5 1.2 1.2Z"/>
  </SvgIcon>
}

export default LineBedQueenIcon
